export default {
	apiKey: "AIzaSyBtcwiqbanNET6Yzo2FA605OjrFM54qvC4",
	authDomain: "tiranaime-49f.firebaseapp.com",
	databaseURL: "https://tiranaime-49f.firebaseio.com",
	projectId: "tiranaime-49f",
	storageBucket: "tiranaime-49f.appspot.com",
	messagingSenderId: "367062117595",
	appId: "1:367062117595:web:053d8a62740cfee8"
};